import React from "react";
import Sidebar from "./components/Sidebar";
import Content from "./components/Content";
import { GlobalStyle } from "./styles/global";
import axios from "axios";
import "./App.css"
const App = () => {
  
  
  return (
    <>
      
      <div style={{ display: "flex" }}>
        <Sidebar />
        <Content />
      </div>
      
    </>
  );
};

export default App;